<div class="data-table">
  <div class="loading-shade" *ngIf="isLoadingResults">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <mat-label class="font-weight-bold">{{ 'forms.common.Criteria.membersEntries' | translate }} </mat-label>

  <form [formGroup]="filtersForm" [dir]="dir">
    <div class="row mt-2 mb-2">
      <mat-form-field class="col-sm-6">
        <mat-label>{{ "forms.common.Criteria.searchKeyword" | translate }}</mat-label>
        <input matInput [placeholder]="'forms.common.Criteria.searchKeyword' | translate" formControlName="keyword" />
      </mat-form-field>

      <mat-form-field class="col-sm-6">
        <mat-label>{{ "forms.common.Criteria.Member" | translate }}</mat-label>
        <mat-select formControlName="memberId">
          <mat-option *ngFor="let option of members$ | async" [value]="option.id">
            {{ option.reviewer | propertyLocalized | async }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="col-sm-12">
        <mat-label>{{ (isMasar ? "forms.common.Criteria.MasarCriteria" : "forms.common.Criteria.Criteria") | translate }}</mat-label>
        <mat-select formControlName="criterionKey">
          <mat-option *ngFor="let option of criterion$ | async" [value]="option.criterionKey">
            <span class="d-inline-block font-weight-bold mx-1 px-2 py-1">{{option.criterionKey}}</span>
            {{ option | propertyLocalized : ['criterionArabicName','criterionEnglishName'] | async}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <div class="d-flex justify-content-end mb-2">
    <button mat-flat-button (click)="onClear()" type="button">
      {{ "forms.common.Criteria.clear" | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="onSearch()" class="mx-2" type="button">
      {{ "forms.common.Criteria.search" | translate }}
    </button>
    <button mat-stroked-button color="warn" (click)="onClose()" type="button">
      {{ "forms.common.Criteria.closeFilter" | translate }}
    </button>
  </div>

  <ng-container *ngIf="dataSource$ | async as dataSource">
    <table mat-table [dataSource]="dataSource?.data">
      <ng-container matColumnDef="{{filter}}">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.summary" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">{{ row[filter] }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="criterionKey">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ (isMasar ? "forms.common.Criteria.MasarCriteria" : "forms.common.Criteria.Criteria") | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="d-inline-block font-weight-bold mx-1 px-2 py-1 chip">{{row.criterionKey}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="member">
        <th mat-header-cell *matHeaderCellDef>
          <strong> {{ "forms.common.Criteria.Member" | translate }}</strong>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="content">{{ row | propertyLocalized : ["memberArabicName", "memberEnglishName"] | async}}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row;let i = index" style="width: 50px">
          <div class="d-flex">
            <button mat-icon-button (click)="copy(row)" matTooltip="{{ 'forms.common.Criteria.copy' | translate }}">
              <mat-icon>content_copy</mat-icon>
            </button>
            <button mat-icon-button (click)="show(row)" matTooltip="{{ 'forms.common.Criteria.View' | translate }}">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="noRecord">
        <td colspan="5" class="text-center" mat-footer-cell *matFooterCellDef>
          {{ "forms.common.No items added yet" | translate }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr [hidden]="!!dataSource?.data?.length" mat-footer-row *matFooterRowDef="
      dataSource?.data?.length === 0 ? ['noRecord'] : []
      "></tr>
    </table>

    <mat-paginator *ngIf="dataSource?.totalItems" [length]="dataSource?.totalItems" [pageSize]="pageSize"
      (page)="changePage($event)">
    </mat-paginator>
  </ng-container>
</div>
